module.exports = __webpack_public_path__ + "media/expire_alert.ab54b719.mp3";